import React, { useEffect, useState } from "react";
import api from '../utils/api';
import { log } from "../utils/debug";
import { Link } from "react-router-dom";
import SortableTable from "../utils/SortableTable";

const ManageEvents = () => {
  const [invites, setInvites] = useState([]);

  useEffect(() => {
    api.get("/my-invites", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      },
      withCredentials: true
    }).then(res => {
      log(res);
      setInvites(res.data);
    }).catch(err => {
      console.error("❌ Failed to load invites:", err);
    });
  }, []);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { month: 'short', day: 'numeric', year: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  }

  const columns = [
    { label: "Event", title: "Event", key: "event_title", width: "40" },
    { label: "Date", title: "Date", key: "event_start", width: "25" },
    { label: "Total", title: "Total", key: "recipients.length", width: "5" },
    { label: <i className="fa-solid fa-check text-approve"></i>, title: "Accepted", key: "counts.yes", width: "5" },
    { label: <i className="fa-solid fa-xmark text-decline"></i>, title: "Declined", key: "counts.no", width: "5" },
    { label: <i className="fa-solid fa-hourglass-half text-await"></i>, title: "Awaiting", key: "counts.none", width: "5" },
    { label: "Action", title: "Action", key: "", width: "15", sortable: false },
  ];

  return (
    <div className="container rsvp">
      <h2><i className="instavite-orange fa-solid fa-envelope"></i> Your Sent Invites</h2>
      {invites.length === 0 ? (
        <p>No invites sent yet.</p>
      ) : (
        <SortableTable
          columns={columns}
          data={invites}
          renderRow={(inv) => (
            <tr key={inv.id}>
              <td width="40"><strong>{inv.event_title}</strong></td>
              <td width="25">{formatDate(inv.event_start)}</td>
              <td width="5">{inv.recipients.length}</td>
              <td width="5">{inv.counts.yes}</td>
              <td width="5">{inv.counts.no}</td>
              <td width="5">{inv.counts.none}</td>
              <td width="15">
                <Link to={`/invite/${inv.id}`} className="instavite-link">
                  View RSVPs
                </Link>
              </td>
            </tr>
          )}
        />
      )}
    </div>
  );
};


export default ManageEvents;
